<template>
    <div class="parkingRes_wrap">
        <div class="join-tab">
            <ul class="join-tab__list">
                <li class="join-tab__item active">
                    <div class="tit">창원파티마병원 주차등록 완료</div>
                </li>
            </ul>
        </div>

        <div class="certification">
            <ul class="contents login-box__list">
                <li class="login-box__item">
                    <h3 class="tit check_mention" style="color: #333;">차량등록이 완료되었습니다.
                        <br>입차시간으로부터 2시간 무료 주차 가능합니다.<br>감사합니다.
                    </h3>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    data() {
      
    },
    mounted() {
       
    },
   
    methods: {
       
    },
}
</script>